import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';

// components
import Btn from '../../components/Btn';

// actions
import { cancelEditing } from '../../reducers/CancelBtn/actions';

class CancelBtn extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { prevState, dispatchCancelEditing } = this.props;
    dispatchCancelEditing(prevState);
  }

  render() {
    const { label, prevState } = this.props;

    if (!_isEmpty(prevState) && prevState.Directions.directionsLoaded) {
      return (
        <Btn styles="cancel-btn" handleClick={this.handleClick}>
          {label}
        </Btn>
      );
    }

    return null;
  }
}

CancelBtn.propTypes = {
  prevState: PropTypes.shape({}).isRequired, // The app state before user began editing their trip details
  label: PropTypes.string.isRequired, // Button label from AEM
  dispatchCancelEditing: PropTypes.func.isRequired, // Reverts App edit state
};

CancelBtn.defaultProps = {};

const mapStateToProps = state => ({
  prevState: state.App.prevState,
  label: state.CancelBtn.label,
});

const mapDispatchToProps = dispatch => ({
  // eslint-disable-next-line arrow-parens
  dispatchCancelEditing: prevState => {
    dispatch(cancelEditing(prevState));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CancelBtn);
